import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { Tag } from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { messages } from './messages'

type Props = {
  historicalPurchaseValue: number | undefined
}

export function HistoricalPurchaseValue(props: Props) {
  const { historicalPurchaseValue } = props

  const { formatCurrency } = useNumbers()
  const { formatMessage } = useIntl()

  if (!historicalPurchaseValue) return null

  const processTooltip = (): string => {
    return formatMessage(
      { ...messages.historicalPurchaseValue.tooltip },
      {
        value: formatCurrency(historicalPurchaseValue),
      }
    )
  }

  return (
    <Tooltip text={processTooltip()}>
      <Tag>
        <FormattedMessage {...messages.historicalPurchaseValue.title} />
      </Tag>
    </Tooltip>
  )
}
